export const AUDIENCE_EVENT_PREFIX = "AUD_";
export const ANALYTICS_PROVIDER = { POSTHOG: "posthog", CUSTOMER_IO: "customerio" } as const;
